<div *ngIf="currentUser" class="navbar-nav user-info-wrapper">
  <div class="topbar-divider d-none d-sm-block"></div>
  <span class="mr-2 d-lg-inline text-gray-600 small user-name" [ngbPopover]="popContent" [popoverTitle]="popTitle" >{{ currentUser.firstName }} {{ currentUser.lastName }}</span>
  <i class="fas fa-user fa-lg fa-fw mr-2 text-dark rounded-circle"></i>

</div>

<ng-template #popContent><span (click)="logout()" class="option" > Logout</span></ng-template>
<ng-template #popTitle>Hi <b>{{ currentUser.firstName }} {{ currentUser.lastName }}</b></ng-template>
